// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.
export const importFeedbackFlag = (): Promise<typeof import('./index')> =>
	import(/* webpackChunkName: "@atlassian/conversation-assistant/feedback-flag" */ './index');
